@if (details$ | async; as details) {
  <div class="flex flex-col gap-8">
    <app-public-brand-banner-carousel [slug]="slug()" />

    <app-brand-details
      [stickyImage]="false"
      [name]="details.name"
      [description]="details.description"
      [homeUrl]="details.homeUrl"
      [illustrationAlt]="details.illustrationAlt"
      [illustrationSrc]="details.illustrationSrc"
      [socials]="details.socials" />
  </div>
} @else {
  <app-spinner-filled />
}
